<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [label]="label"
  [areaName]="areaName"
  [model]="model"
  [hasCheckBoxLookUpTree]="hasCheckBoxLookUpTree"
  [columns]="columns"
  (valueChangeByApiName)="onChange($event)"
  (onRowSelected)="onRowSelected($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="GoodsUnits && GoodsUnits.length > 0">
    <ssg-tabset (tabChange)="selectTab($event)" class="tabcontainer tabcontentbox">
      <ssg-tab tabTitle="واحد سنجش فرعی">
        <editable-grid
          #defaultUnit
          *ngIf="isActveTab('واحد سنجش فرعی')"
          [columns]="GoodsUnits"
          [dataList]="model.GoodsUnits"
          [isAdd]="true"
          (valueChanges)="valueChanges($event)"
          [isDelete]="true">
        </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="بارکد">
        <editable-grid
          #goodsBarCodes
          *ngIf="isActveTab('بارکد')"
          [columns]="GoodsBarCodes"
          [dataList]="model.GoodsBarCodes"
          [isAdd]="true"
          [isDelete]="true">
        </editable-grid>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
